module.exports = __webpack_public_path__ + "assets/img/l5.1a22faec.png";